import { Box, Container, Typography, useMediaQuery } from "@mui/material";
import React from "react";
export default function Why() {
  const matches = useMediaQuery("(max-width:1050px)");

  return (
    <Box mt={{ xs: 5, md: 20 }} mb={{ xs: 5, md: 5 }}>
      <Container>
        <Box
          display="flex"
          justifyContent="center"
          flexDirection="column"
          sx={{
            borderRadius: "40px",
            background: "#27ADFB",
            p: { xs: 3, md: 6 },
            boxShadow:
              "0px 2px 4px 0px #0000004D inset,0px -2px 4px 0px #FFFFFF8C inset",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Lilita One",
              fontSize: { xs: "45px", sm: "70px" },
              lineHeight: { xs: "40px", sm: "30px" },
              textAlign: "center",
              color: "#65CD2E",
              WebkitTextStroke: "3px #ffffff",
            }}
          >
            Why BARFBOY?
          </Typography>
          <Typography
            pl={{ md: 10, xs: 0 }}
            pr={{ md: 10, xs: 0 }}
            sx={{
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: { md: "24px", xs: "16px" },
              fontWeight: "400",
              color: "#fff",
              pt: 7,
            }}
          >
            <span style={{ fontWeight: "700" }}>Newly Launched: </span> You’re
            early. Like, really early.
            <br />
            <span style={{ fontWeight: "700" }}>Community-Driven: </span> A
            memecoin built on pure chaos and community power.{" "}
          </Typography>
          {/* <br /> */}
          <Typography
            mt={matches ? 0.5 : 3}
            px={{ md: 10, xs: 0 }}
            sx={{
              textAlign: "center",
              fontFamily: "Montserrat",
              fontSize: { md: "24px", xs: "16px" },
              fontWeight: "400",
              color: "#fff",
            }}
          >
            <span style={{ fontWeight: "700" }}> Diamond Hands Only: </span> If
            you can’t handle the ride, step aside.
            <br />
            <span style={{ fontWeight: "700" }}>No Presale: </span>
            100% fair launch—this one’s for the people.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
